import React from "react";
import "./PersonCard.css";
import defaultHeaderPhoto from "../../defaultHeaderPhoto.png";
import { Person } from "../Types/Configuration";
import { imageServerUrl, imageSizes } from "../../constants/config";

interface PersonCardProps {
  person:Person ;
}
const PersonCard: React.FC<PersonCardProps> = ({ person }) => {
    return (
        <div className="person-card-container">
            <img src={person.imageUrl ? `${imageServerUrl}/image/${imageSizes.thumbnail}/${person.imageUrl}` : defaultHeaderPhoto} alt={person.name} className="person-card-photo" />
            <div className="person-card-info">
                <div className="person-card-name">{person.name}</div>
                <div className="person-card-title">{person.title}</div>
                <div className="person-card-contact">{person.email}</div>
                <div className="person-card-contact">{person.phone}</div>
            </div>
        </div>
    )
}
export default PersonCard;